export const VARIATION_CROSS_SELL = 'cross-sell'
export const VARIATION_PLP = 'plp'

export interface CapsuleFeaturesInputType {
    acidity?: number | null
    bitterness?: number | null
    body?: number | null
    intensity?: number | null
    roastLevel?: number | null
}

export interface CapsuleFeatureType {
    value: number | null
}

export interface CapsuleFeaturesOutputType {
    acidity: CapsuleFeatureType
    bitterness: CapsuleFeatureType
    body: CapsuleFeatureType
    intensity: CapsuleFeatureType
    roast: CapsuleFeatureType
}

export type QuickViewProductType = {
    modelType: string
    id: string
    legacyId: string
    internationalId: string
    name: string
    urlFriendlyName: string
    internationalName: string
    headline: string
    rootCategory: string
    category: string
    supercategories: string[]
    mobileImages: {
        modelType: string
        icon: string
        main: string
    }
    responsiveImages: {
        standard: string
    }
    pdpURLs: {
        opr: string
        desktop: string
        mobile: string
    }
    unitQuantity: number
    salesMultiple: number
    maxOrderQuantity: number
    technologies: string[]
    comingSoon: boolean
    unit_quantity: number
    productSelections: string[]
    type: string
    priceDisplay: string
    isOrderable: boolean
    bundled: boolean
    capsuleProperties: {
        intensity: number
        bitterness: number
        acidity: number
        roastLevel: number
    }
    capsuleProductAromatics: string[]
    aromaticProfileDescription: string
    roastingDescription: string
    capsuleCupSizes: string[]
    capsuleCupSizesDetails: {
        id: string
        name: string
        capacityLabel: string
    }[]
    capsuleAromatics: {
        id: string
        name: string
    }[]
    decaffeinated: boolean
}

//Confirmed this props are not available in Product Type
export type ProductNewPropsType = {
    currency: string
    pdpURLs: {
        desktop: string
        mobile: string
    }
    responsiveImages: {
        standard: string
    }
    supercategories: string[]
    productSelections: string[]
    capsuleProperties?: CapsuleFeaturesInputType
    capsuleProductAromatics: string[]
    unitPrice: number
    cupSizesDetails?: {
        icon: string
        label: string
        size: string
        capacityLabel: string | null
        category: {
            id: string
            name: string
            description: string | null
            icon: {
                url: string
                altText: string
            }
            detailsIcon: {
                url: string
                altText: string
            }
            url: string | null
            capacityLabel: string | null
            rangeLink: string | null
            subCategories: []
            superCategories: string[]
        }
    }[]
    category_name: string
    url: string
}

// This is the Product Type signature Combined
export type ProductPropsType = QuickViewProductType & ProductNewPropsType

export type AddToCartPropsType = {
    sku?: string
    longSku?: string
    category_name?: string
    price?: string
    strikethrough_price?: number
    hidePrice?: boolean
    type?: string
    price_per_capsule?: number | string
    show_capsule_price?: boolean
    label_capsules?: string
    capsule_price_label?: string
    capsule_price_syntax?: string
    show_sleeve_price?: boolean
    show_sleeve?: boolean
    sleeve_syntax?: string
    number_of_sleeves?: number
    label_sleeves?: string
    label_sleeve?: string
    technologies: string[]
    sales_multiple?: number
    unitQuantity?: number
    unit_quantity?: number
    bundled?: boolean
    url?: string
}

export type PageBuilderProductPropsType = {
    sku: string
    highlighted: boolean
    labels: {
        bgColor: string
        color: string
        name: string
    }[]
    strikethrough_price: string
    variant: {
        is_capsule: boolean
        number_of_sleeves: number
        number_of_capsules: string
        bundle_details: {
            popin_link_text: string
            popin_label_close: string
            description: string
            other_skus: string
            other_skus_quantity: string
        }
        logos: {
            fair_trade: boolean
            alt_fair_trade: string
            is_organic: boolean
            alt_organic: string
            only_vertuo_next: boolean
            alt_vertuo_next: string
            is_rainforest: boolean
            alt_rainforest: string
            is_sustainable: boolean
            alt_sustainable: string
            is_q_certified_arabica: boolean
            alt_q_certification_arabica: string
        }
        sku_timer: {
            launch_date: string
            remaining_days: string
            remaining_day: string
            label: string
            a11y_label: string
        }
        ingredients: {
            heading: string
            description: string
        }
    }
}

export type PageBuilderPropsType = {
    quick_view_plp?: {
        popin?: {
            close?: string
        }
        cup_sizes?: {
            heading: string
            unit_is_oz: boolean
            items: string[]
        }
        aromatic_profile?: {
            heading: string
            items: string[]
        }
        link?: {
            label: string
            url: string
        }
        levels?: {
            a11y_level_of: string
            acidity_label: string
            bitterness_label: string
            roastiness_label: string
            body_label: string
        }
    }
    campaign?: {
        id?: string
        name?: string
        creative?: string
        position?: string
    }
    tracking_position: string
    tracking_list: string
    capsuleProperties?: CapsuleFeaturesInputType
    price_per_capsule?: number | string
    show_capsule_price?: boolean
    label_capsules?: string
    capsule_price_label?: string
    capsule_price_syntax?: string
    show_sleeve_price?: boolean
    show_sleeve?: boolean
    sleeve_syntax?: string
    number_of_sleeves?: number
    label_sleeves?: string
    label_sleeve?: string
    technologies: string[]
    sales_multiple?: number
    unit_quantity?: number
    bundled?: boolean
    pdpURLs: {
        desktop: string
        mobile: string
    }
    intensity_label: string
    products: {
        sku: string
        longSku: string
        price: number
        strikethrough_price: number
        hidePrice: boolean
        url: string
    }[]
    priceFormatter: {
        formatPrice: (price: number) => string
    }
    currency: string
    options: {
        intensity_label: string
        show_sleeve: boolean
        label_sleeve: string
        label_sleeves: string
        label_capsules: string
        sleeve_syntax: string
        show_sleeve_price: boolean
        capsule_price_label: string
        capsule_price_syntax: string
        a11y_intensity_max: string
        label_decaffeinato: string
        is_headline_hidden: boolean
        sizes_title: string
        notes_title: string
        enabledExperiments: string[]
    }
    copywriting: {
        sku_quick_view: {
            more_info: string
            a11y_more_info: string
            popin: {
                close: string
            }
            cup_sizes: {
                heading: string
                unit_is_oz: boolean
                items: string[]
            }
            aromatic_profile: {
                heading: string
                items: string[]
            }
            link: {
                label: string
            }
        }
        aromatic_profile: {
            heading: string
            items: string[]
        }
    }
}

export type SkuType = {
    tracking_list: string
    tracking_position: string
    id: string
    sku: string
    longSku: string
    name: string
    name_custom: string
    available: boolean
    description: string | null
    hidePrice: boolean
    image_alt_text: string
    inStock: boolean
    internationalId: string
    internationalName: string
    legacyId: string
    maxOrderQuantity: number | null
    packagingType: string | null
    price: string
    pushRatingEnabled: boolean
    ranges: string[]
    salesMultiple: number
    technologies: string[]
    type: string
    unitQuantity: number
    url: string
    labels: []
    category_name: string
    category: {
        id: string
        name: string
        description: string | null
        icon: {
            url: string
            altText: string | null
        }
        detailsIcon: string | null
        url: string | null
        capacityLabel: string | null
        rangeLink: string | null
        subCategories: []
        superCategories: string[]
    }
    highlighted: boolean
    strikethrough_price: string
    view_details_label: string
    headline: string
    cupSizes: string[]
    cupSizesDetails: {
        icon: string
        label: string
        size: string
        capacityLabel: string | null
        category: {
            id: string
            name: string
            description: string | null
            icon: {
                url: string
                altText: string | null
            }
            detailsIcon: string | null
            url: string | null
            capacityLabel: string | null
            rangeLink: string | null
            subCategories: []
            superCategories: string[]
        }
    }[]
    flavors: string[]
    in_stock: boolean
    sales_multiple: number
    bundled: boolean
    logos: []
    is_headline_hidden: boolean
    a11y_price: string
    a11y_product_card: string
    label_sleeve: string
    label_sleeves: string
    label_capsules: string
    intensity: number
    a11y_intensity_max: string
    label_decaffeinato: string
    show_sleeve_price: boolean
    show_sleeve: boolean
    price_per_capsule: number | string
    final_price: string | null
    capsule_price_label: string
    capsule_price_syntax: string
    sleeve_syntax: string
    perSleeveLabel: string
    number_of_sleeves: number
    number_of_capsules: string
    show_capsule_price: boolean
    sort_price: number
    bundle_details: any
    quick_view_plp: {
        show_view: boolean
        quick_view_text: string
        popin: {
            close: string
        }
        cup_sizes: {
            heading: string
            unit_is_oz: boolean
            items: string[]
        }
        aromatic_profile: {
            heading: string
            items: string[]
        }
        link: {
            label: string
        }
        levels: {
            a11y_level_of: string
            acidity_label: string
            bitterness_label: string
            roastiness_label: string
            body_label: string
        }
    }
    hasPricePerSleeve: boolean
    sleevePrice: string
    rendererName: string
    position: number
    rawPrice: number
    variation: string
    intensity_label: string
    campaign: {
        id: string
        name: string
        creative: string
        position: string
    }
    capsuleProductAromatics: string[]
    copywriting: {
        heading: string
        sku_quick_view: {
            more_info: string
            a11y_more_info: string
            popin: {
                close: string
            }
            cup_sizes: {
                heading: string
                unit_is_oz: false
                items: string[]
            }
            aromatic_profile: {
                heading: string
                items: string[]
            }
            link: {
                label: string
            }
        }
        aromatic_profile: {
            heading: string
            items: string[]
        }
    }
    options: {
        intensity_label: string
        show_sleeve: boolean
        label_sleeve: string
        label_sleeves: string
        label_capsules: string
        sleeve_syntax: string
        show_sleeve_price: boolean
        capsule_price_label: string
        capsule_price_syntax: string
        a11y_intensity_max: string
        label_decaffeinato: string
        is_headline_hidden: boolean
        sizes_title: string
        notes_title: string
        enabledExperiments: string[]
    }
    products: {
        sku: string
        longSku: string
        price: number
        strikethrough_price: number
        hidePrice: boolean
        url: string
    }[]
    priceFormatter: {
        formatPrice: (price: number) => string
    }
    currency: string
}

export type MergedProductType = {
    intensity_label: string
    capsuleProductAromatics?: string[]
    pdpURLs?: {
        desktop: string
        mobile: string
    }
}

export type AddToCardPropertiesType = SkuType & MergedProductType

type CupSizeType = {
    icon: string
    label: string
    size: string
    capacityLabel: string | null
    category: {
        id: string
        name: string
        description: string | null
        icon: {
            url: string
            altText: string
        }
        detailsIcon: {
            url: string
            altText: string
        }
        url: string | null
        capacityLabel: string | null
        rangeLink: string | null
        subCategories: []
        superCategories: string[]
    }
}[]

export type QuickViewPropsType = {
    popin: {
        popin_id: string
        close?: string
        footer: boolean
    }
    product: MergedProductType
    intensity: {
        intensity_label?: string
        a11y_intensity_max: string
    }
    cup_sizes: {
        heading: string
        unit_is_oz: boolean
        items?: [] | CupSizeType
    }
    aromatic_profile: {
        heading: string
        items: string[]
    }
    link: {
        label: string
        url?: string
    }
    levels: any
    pricing: {
        add_to_cart: AddToCartPropsType & {
            position: string
            variation: string
            url: string
            view_details_label: string
            rendererName: string
        }
        showSleeve: any
        showCapsulePrice: any
    }
    campaign: any
}
